import { createClient, adaptContentfulFormToFormSchema } from '~/services/origins/contentful';
import type { ComponentFormSkeleton } from '~/services/origins/contentful';
import type { FormSchema } from '~/shared/domain/models';

type GetForm = (id: string) => Promise<FormSchema>;

export const getForm: GetForm = async (id) => {
  const client = createClient();
  const contentfulForm = await client.withoutUnresolvableLinks.getEntry<ComponentFormSkeleton>(id, {
    include: 10,
  });

  const adaptedForm = adaptContentfulFormToFormSchema(contentfulForm);

  return adaptedForm;
};
